




























import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';
import parseISO from 'date-fns/parseISO';
import addDays from 'date-fns/addDays';
import isValid from 'date-fns/isValid';
import differenceInSeconds from 'date-fns/differenceInSeconds';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInHours from 'date-fns/differenceInHours';
import isSaturday from 'date-fns/isSaturday';
import isSunday from 'date-fns/isSunday';

@Component
export default class AvailabilityClock extends Mixins(BaseMixin) {
    @Prop(String)
    private nextPossibleShippingDateTimeISO8601!: string;

    private totalSecondsLeft: number = 0;

    private hidden: boolean = false;

    private nextPossibleShippingDateTime: Date | null = null;

    public get days(): number {
        return Math.floor(this.totalSecondsLeft / (3600 * 24));
    }

    public get hours(): number {
        return Math.floor((this.totalSecondsLeft % (3600 * 24)) / 3600);
    }

    public get minutes(): number {
        return Math.floor(((this.totalSecondsLeft % (3600 * 24)) % 3600) / 60);
    }

    public get seconds(): number {
        return ((this.totalSecondsLeft % (3600 * 24)) % 3600) % 60;
    }

    protected created(): void {
        if (this.nextPossibleShippingDateTimeISO8601 == null) {
            this.hidden = true;
            return;
        }
        this.nextPossibleShippingDateTime = parseISO(this.nextPossibleShippingDateTimeISO8601);

        if (!isValid(this.nextPossibleShippingDateTime)) {
            this.hidden = true;
            return;
        }
        this.totalSecondsLeft = differenceInSeconds(this.nextPossibleShippingDateTime, new Date(Date.now()));
        this.countdown();
        window.setInterval(this.countdown, 1000);
    }

    private countdown(): void {
        const now = new Date(Date.now());

        if (
            this.nextPossibleShippingDateTime != null &&
            (this.totalSecondsLeft <= 0 || this.nextPossibleShippingDateTime <= now)
        ) {
            this.nextPossibleShippingDateTime = addDays(this.nextPossibleShippingDateTime, 1);
            if (isSaturday(this.nextPossibleShippingDateTime)) {
                addDays(this.nextPossibleShippingDateTime, 2);
            }
            if (isSunday(this.nextPossibleShippingDateTime)) {
                addDays(this.nextPossibleShippingDateTime, 1);
            }
            this.totalSecondsLeft = differenceInSeconds(this.nextPossibleShippingDateTime, now);
        }

        if (this.totalSecondsLeft !== 0) {
            this.totalSecondsLeft -= 1;
        }
    }
}
